import { Component, OnInit, Input, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { DatetimeService, ChiSoCongToKHService, ThongTinDiemDoService } from '../../../../services/index';
import { Message } from 'primeng/components/common/message';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
@Component({
  selector: 'modal-chitietchiso',
  templateUrl: './chisocongtokh-chitiet.component.html',
  styleUrls: ['./chisocongtokh-chitiet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChiSoChiTietComponent implements OnInit, OnChanges {
  @Input() loaipha: number = 1;
  @Input() meterid: number;
  @Input() tendiemdo: string;
  @Input() loaichisoct: number = 1;
  @Input() paraQueryNgay: any;
  @Input() paraQueryToNgay: any;
  @Input() loaiHienThi: number = 1;
  hesonhan: Number = 1;
  isShowProgress: number = 0;
  paraQueryTuNgay: any;
  paraQueryDenNgay: any;
  maxDate: Date;
  paraQuerySocongto: any;
  lstSocongto: any = [];
  totalRows: number = -1;
  totalPage: number = 0;
  currentPage: number = 0;
  disableExcel = true;
  msgs: Message[] = [];
  lstChiSoChiTiet: any = [];
  numRecs = 20;
  constructor(private thongtindiemdoService: ThongTinDiemDoService, private chiSoCongToService: ChiSoCongToKHService
    , private dateTimeService: DatetimeService
    , private translate: TranslateService
  ) {
    translate.use(localStorage.getItem(environment.LANGUAGE));
  }

  ngOnInit() {

    this.maxDate = new Date();
    if (this.paraQueryNgay != undefined) {

      this.paraQueryTuNgay = this.paraQueryNgay;
      this.paraQueryDenNgay = this.paraQueryToNgay;
    }
    else {
      this.paraQueryTuNgay = new Date();
      this.paraQueryDenNgay = new Date();
    }
    this.paraQuerySocongto = '0';
    //this.thuchien(0);
  }
  ngOnChanges(changes: SimpleChanges) {
    this.layDScongto();
  }
  public layDScongto() {
    this.meterid
    this.chiSoCongToService.getDsCongto(
      this.meterid).subscribe(response => {
        let dataRet = (response);
        this.lstSocongto = [];
        this.lstSocongto.push({ label: "--Tất cả--", value: 0 });
        dataRet.data.forEach((item, index) => {
          this.lstSocongto.push({ label: item.socongto, value: item.sct_value });
        });
        this.thuchien(0);
      });
  }

  thuchien(index) {
    this.msgs = [];
    this.msgs = [];
    // if (this.dateTimeService.calculateTwoDate(this.paraQueryDenNgay, this.paraQueryTuNgay) > 7) {
    //   this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Chỉ truy xuất tối đa trong khoảng 7 ngày' });
    //   return false;
    // }
    if (this.dateTimeService.compareTwoDate(this.paraQueryTuNgay, this.paraQueryDenNgay) === 1) {
      this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Ngày bắt đầu không được lớn hơn ngày kết thúc' });
      return false;
    }
    this.lstChiSoChiTiet = [];
    this.isShowProgress = 1;
    this.chiSoCongToService.getChiTietChiSoCongToKH(this.meterid, this.loaiHienThi == 1 ? "MH" : "TG", this.paraQuerySocongto,
      this.dateTimeService.convertDatetoDateOnlyString(this.paraQueryTuNgay),
      this.dateTimeService.convertDatetoDateOnlyString(this.paraQueryDenNgay), index, this.numRecs, this.loaichisoct).subscribe(res => {
        let _ret = (res);
        if (_ret.data.length > 0) {
          this.lstChiSoChiTiet = _ret.data;
          this.totalRows = _ret.data[0].rowscount;
          this.currentPage = _ret.data[0].pagenum;
          this.totalPage = _ret.data[0].totalpage;
          this.disableExcel = false;
          this.hesonhan = _ret.data[0].tieude;
        }
        else {
          // this.msgs.push({ severity: 'info', summary: 'Thông báo', detail: 'Có tất cả 0 kết quả' });
          this.totalRows = 0;
          this.currentPage = 0;
          this.totalPage = 0;
        }
        this.isShowProgress = 0;
      });
  }

  excelChiSo() {
    this.isShowProgress = 1;
    let thoiDiemTruyVan = "Từ ngày " + this.dateTimeService.convertDatetoDateOnlyString(this.paraQueryTuNgay) + " đến ngày " + this.dateTimeService.convertDatetoDateOnlyString(this.paraQueryDenNgay);
    this.chiSoCongToService.exportExcelChiSoCongToChiTiet(this.meterid, this.loaiHienThi == 1 ? "MH" : "TG", this.paraQuerySocongto, this.dateTimeService.convertDatetoDateOnlyString(this.paraQueryTuNgay), this.dateTimeService.convertDatetoDateOnlyString(this.paraQueryDenNgay), this.loaipha, this.tendiemdo, "Chi tiết chỉ số công tơ khách hàng", "Chi tiết chỉ số công tơ khách hàng", thoiDiemTruyVan, this.loaichisoct).subscribe(
      response => {
        this.isShowProgress = 0;
      });
  }

  changeOption() {
    this.disableExcel = true;
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/giam-sat/chi-so-cong-to-kh/chi-tiet/chisocongtokh-chitiet.component.ts